// src/services/container.ts
import { createContainer, asClass, InjectionMode } from "awilix"
import { AppApiService } from "./services/api"
import { AppHttpService } from "./services/http"
import { AppLogger } from "./services/logger"
import { AppSessionService } from "./services/session"

// Create Awilix container
export const loadContainer = () => {
  const Container = createContainer({
    injectionMode: InjectionMode.PROXY,
  })

  Container.register({
    logger: asClass(AppLogger).scoped(),
    sessionService: asClass(AppSessionService).singleton(),
    httpService: asClass(AppHttpService).scoped(),
    apiService: asClass(AppApiService).scoped(),
  })

  return Container
}

export const container = loadContainer()